import React, { Fragment, useEffect, useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
  Box,
  IconButton,
  TextField,
  MenuItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { updateEndorsementFormData } from "src/features/rfqDataSlice";
import request from '../../../../utils/request';

const HypotheticalDetails = ({ policyDetails }) => {
  const dispatch = useDispatch();
  const [bankData, setBankData] = useState<any[]>([]);
  useEffect(() => {
    getBankData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getBankData = async () => {
    request({
      url: 'bank/getBankList',
      method: 'post',
      data: {

        orderColumn: 'name',
        orderDirection: 'ASC',
        offset: 0,
        limit: 10000,
        status: true
      }
    }).then(
      (response) => {
        setBankData([]);
        setBankData(response['bankData']);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const [rows, setRows] = useState(
    policyDetails?.hypothecations || []
  );

  const [editingIndex, setEditingIndex] = useState(null);
  const [tempRow, setTempRow] = useState(null);

  // Select existing item for update
  const handleSelect = (index, checked) => {
    const updated = [...rows];

    updated[index] = {
      ...updated[index],
      isSelected: checked,
      action_type: checked ? "update" : null,
    };

    setRows(updated);
  };


  const handleDelete = (index) => {
    const updated = [...rows];

    updated[index] = {
      ...updated[index],
      action_type: "delete",
      isSelected: false,
    };

    setRows(updated);
  };

  // Add new row (inline edit mode)
  const handleAdd = () => {
    setEditingIndex(rows.length);
    setTempRow({
      bank: "",
      branch: "",
      action_type: "create",
      isSelected: false,
    });
  };

  const handleTempChange = (field, value) => {
    setTempRow((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    const updated = [...rows];
    updated.push(tempRow);
    setRows(updated);
    setEditingIndex(null);
    setTempRow(null);
  };

  const handleCancel = () => {
    setEditingIndex(null);
    setTempRow(null);
  };

  // Sync Redux
  useEffect(() => {
    dispatch(
      updateEndorsementFormData({
        hypothetical_details: rows,
      })
    );
  }, [rows, dispatch]);

  if (!rows?.length && editingIndex === null) return null;

  return (
    <>
      <Box sx={{ mb: 1 }}>
        <Typography
          variant="h5"
          sx={{
            background: "rgb(9 84 174)",
            color: "#fff",
            py: 1,
            fontWeight: "bold",
            pl: 2,
          }}
        >
          Hypothecation Details
        </Typography>
      </Box>

      <Grid container spacing={2} sx={{ pl: 2 }}>
        {/* Existing Rows */}
        {rows.map((row, index) => {
          // if (row.action_type === "delete") return null;

          const isNew = row.action_type === "create";

          return (
            <Grid
              item
              xs={12}
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #eee",
                pb: 0,
                background: row.action_type === "delete" ? "#ffe6e6" : "inherit",
                pt:0,

              }}
            >
              <FormControlLabel
                control={<></>}
                label={`${row.bank} - ${row.branch}`}
                sx={{
                  textDecoration: row.action_type === "delete" ? "line-through" : "none",
                  color: row.action_type === "delete" ? "error.main" : "inherit"
                }}

              />

              <IconButton
                color="error"
                onClick={() => handleDelete(index)}
              >
                <DeleteIcon />
              </IconButton>
            </Grid>
          );
        })}

        {/* Inline Add Editor */}
        {editingIndex !== null && tempRow && (
          <>
            <Grid item xs={5}>

              <TextField
                size="small"
                select
                label={
                  <Fragment>
                    Bank{' '}
                    {/* <Typography component="span" sx={{ color: 'red' }}>
                      *
                    </Typography> */}
                  </Fragment>
                }

                fullWidth
                value={tempRow.bank}
                onChange={(e) =>
                  handleTempChange("bank", e.target.value)
                }

              >
                {bankData.map((bank) => (
                  <MenuItem key={bank.id} value={bank.name}>
                    {bank.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={5}>
              <TextField
                fullWidth
                size="small"
                label="Branch"
                value={tempRow.branch}
                onChange={(e) =>
                  handleTempChange("branch", e.target.value)
                }
              />
            </Grid>

            <Grid
              item
              xs={2}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <IconButton
                color="success"
                onClick={handleSave}
              >
                <CheckIcon />
              </IconButton>

              <IconButton
                color="error"
                onClick={handleCancel}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </>
        )}

        {/* Add Button */}
        {editingIndex === null && (
          <Grid item xs={12} textAlign="center">
            <IconButton onClick={handleAdd} color="primary">
              <AddIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default HypotheticalDetails;
